import { render, staticRenderFns } from "./NoticePreviousNext.vue?vue&type=template&id=1c535036&"
import script from "./NoticePreviousNext.vue?vue&type=script&lang=js&"
export * from "./NoticePreviousNext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports